/*
 * @Author: your name
 * @Date: 2021-02-21 22:03:08
 * @LastEditTime: 2021-08-23 01:04:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /red_packet_admin/src/api/modules/user.js
 */
import request from "../request";

// 基本信息保存
export function getToken(code) {
  return request({
    url: "/wechat/authUser",
    method: "post",
    data: { code },
  });
}
